import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { NotificationHub } from "./NotificationHub";
import { NotificationHubService } from "./NotificationHubService";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";
import { UserNotificationManager } from "./UserNotificationManager";
import { UserNotificationManagerService } from "./UserNotificationManagerService";

export async function registerModuleNotificationsAsync(configuration: Configuration)
{
    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
    ServiceManager.add(NotificationHubService, new NotificationHub());
    ServiceManager.add(UserNotificationManagerService, new UserNotificationManager());
}